/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CollectionIcon = /*#__PURE__*/ createSvgIcon(
  'CollectionIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 11.437a1.586 1.586 0 01-.792-.208L2.167 7.396a.74.74 0 01-.323-.313.919.919 0 01-.094-.416c0-.153.031-.292.094-.417a.74.74 0 01.323-.313l7.041-3.833a1.59 1.59 0 011.198-.156c.132.035.26.087.386.156l7.041 3.833a.74.74 0 01.323.313.917.917 0 01.094.417.917.917 0 01-.094.416.74.74 0 01-.323.313l-7.041 3.833a1.585 1.585 0 01-.792.208zm0-1.666l5.688-3.104L10 3.562 4.312 6.667 10 9.77zm0 3.333l6.542-3.562a3.72 3.72 0 01.395-.105c.237 0 .434.08.594.24.16.16.24.358.24.594a.844.844 0 01-.104.416.81.81 0 01-.334.313l-6.541 3.562a1.59 1.59 0 01-1.198.156 1.665 1.665 0 01-.386-.156L2.667 11a.81.81 0 01-.334-.313.843.843 0 01-.104-.416c0-.236.08-.434.24-.594a.806.806 0 01.791-.208c.063.02.129.045.198.073L10 13.104zm0 3.333l6.542-3.562c.027-.014.16-.049.395-.104.237 0 .434.08.594.24.16.16.24.357.24.593a.844.844 0 01-.104.417.811.811 0 01-.334.312l-6.541 3.563a1.59 1.59 0 01-1.198.156 1.664 1.664 0 01-.386-.156l-6.541-3.563a.811.811 0 01-.334-.312.843.843 0 01-.104-.417c0-.236.08-.434.24-.594a.806.806 0 01.791-.208c.063.02.129.045.198.073L10 16.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CollectionIcon;
